import httpAuth from '@/services/httpAuth'

import { serialize2 } from '@/services/object'
import { serializePaginate } from '@/services/serialize'

export async function list (url, modulo, filtros) {
  return httpAuth.get(`${url}?${serialize2(filtros)}`, { tela: modulo })
}

// Sem Serialize
export async function list2 (url, filtro, pagination) {
  // console.log(url)
  // console.log(pagination)
  return httpAuth.get(`${url}?${filtro.query}&${serializePaginate(pagination)}`)
}

export async function get (url, modulo, id) {
  return httpAuth.get(`${url}/${id}`, { tela: modulo })
}

export async function add (url, funcionalidade, dados) {
  return httpAuth.post(`${url}`, dados, { funcionalidade: funcionalidade })
}

export async function edit (url, funcionalidade, id, dados) {
  return httpAuth.put(`${url}/${id}`, dados, { funcionalidade: funcionalidade })
}

export async function del (url, funcionalidade, id) {
  return httpAuth.delete(`${url}/${id}`, { funcionalidade: funcionalidade })
}
